import type { SidebarInputMode } from '@/lib/chat/types';

export function applySidebarInputToDraft(
  currentInput: string,
  sidebarInput: string,
  mode: SidebarInputMode,
): string {
  if (mode !== 'append') {
    return sidebarInput;
  }

  const trimmedCurrentInput = currentInput.trimEnd();
  return trimmedCurrentInput ? `${trimmedCurrentInput}\n\n${sidebarInput}` : sidebarInput;
}

export function buildChatDraftStorageKey(chatId: string): string {
  return `chat-input:${chatId}`;
}

export function readChatDraftValue(chatId: string): string {
  if (typeof window === 'undefined') {
    return '';
  }

  let rawValue: string | null = null;
  try {
    rawValue = window.localStorage.getItem(buildChatDraftStorageKey(chatId));
  } catch {
    // Some browsers/privacy modes throw SecurityError on storage reads.
    return '';
  }

  if (!rawValue) {
    return '';
  }

  try {
    const parsedValue = JSON.parse(rawValue) as unknown;
    return typeof parsedValue === 'string' ? parsedValue : '';
  } catch {
    // Handle non-JSON values from older localStorage writes.
    return rawValue;
  }
}

export function getInitialChatInput({
  chatId,
  sidebarInput,
  mode,
}: {
  chatId: string;
  sidebarInput: string;
  mode: SidebarInputMode;
}): string {
  const storedDraft = readChatDraftValue(chatId);
  return sidebarInput ? applySidebarInputToDraft(storedDraft, sidebarInput, mode) : storedDraft;
}
